import { render, staticRenderFns } from "./LandingPricing.vue?vue&type=template&id=73120355&scoped=true"
import script from "./LandingPricing.vue?vue&type=script&lang=js"
export * from "./LandingPricing.vue?vue&type=script&lang=js"
import style0 from "./LandingPricing.vue?vue&type=style&index=0&id=73120355&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73120355",
  null
  
)

export default component.exports